export default __webpack_public_path__ + "static/tab-banner-320d3266a78026cd5af1d09ffbbda233.png";